import React from 'react';
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { Route, /* BrowserRouter as Router, */ /* MemoryRouter, */Link as RouterLink  } from "react-router-dom";
import {Button, Paper, Grid, Typography} from '@material-ui/core';

class SegmentFilter extends React.Component {
    /* constructor(props) {
      super(props);
    } */
    handleFilterTextChange(e) {
        this.props.onFilterTextChange(e);
    }
    
    render() {
      
    function SimpleBreadcrumbs() {
      return (
        <Route>
          {({ location }) => {
            const pathnames = location.pathname.split("/").filter(x => x);
            return (
              <Breadcrumbs aria-label="Breadcrumb">
                <RouterLink color="inherit" to="/">
                  Home
                </RouterLink>
                {pathnames.map((value, index) => {
                  const last = index === pathnames.length - 1;
                  const to = `/${pathnames.slice(0, index + 1).join("/")}`;

                 /*  return last ? (
                    <Typography color="textPrimary" key={to}>
                      {value}
                    </Typography>
                  ) : (
                    <RouterLink color="inherit" to={to} key={to}>
                      {value}
                    </RouterLink>
                  ); */
                 return last ? (
                    <Typography variant="body2" key={to}>
                      Resultados
                    </Typography>
                  ) : value === 'trenes'?
                      (<RouterLink variant="body2" to={to} key={to}>
                          Trenes
                      </RouterLink>):''; 
                })}
              </Breadcrumbs>
            );
          }}
        </Route>
      );
    }
      return (
        <Paper className="breadcrumbs-leyend" elevation={0}>
          <Grid container spacing={0}>
            <Grid item md={12}>
              <div className="breadcrumb">
              <SimpleBreadcrumbs />
              {/*   <Typography variant="body2"><Link>Inicio</Link> / <Link>Trenes</Link> / Resultados</Typography>  */}
              </div>  
            </Grid>
            {/* <Grid item md={6}>
              <div className="leyend">
                <form>
                  <Typography display="inline" variant="body2">Filtra tu búsqueda:</Typography>
                  <Button size="small" variant="contained" className="btn-filter cheaper" onClick={this.handleFilterTextChange.bind(this, "BEST_PRICE")}>Mejor precio</Button>
                  <Button size="small" variant="contained" className="btn-filter more-flexible" onClick={this.handleFilterTextChange.bind(this, "MOST_FLEXIBLE")}>Más flexible</Button>
                  <Button size="small" variant="contained" className="btn-filter btn-clear btn-clear-filters" onClick={this.handleFilterTextChange.bind(this, "DELETE_FILTER")}>Borrar filtros</Button>
                </form>
              </div>
            </Grid> */}
          </Grid>
        </Paper>
      )
    }
  }

export default SegmentFilter;